angular.module('EMR.Admin') 
/**
 * this directivev is to check if the fax service is enabled for the practice on click or enter events
 */
    .directive('emrActionSendFax', ['EMRActionFaxService', function (EMRActionFaxService) { 
        return { 
            restrict: 'A', 
            scope: { 
                clickHandler: '&emrActionSendFax', 
            }, 
            link: function (scope, element) { 
                //bind keydown and keypress evnt 
                element.bind("keydown keypress", function (event) { 
                    //checking if the key is "Enter"
                    if (event.which === 13 ) {
                        //then prevent default action and go on with flow mentioned here
                        event.preventDefault();
                        if(!EMRActionFaxService.isFaxEnabledServiceCallSent){
                            EMRActionFaxService.faxserviceValidationforFaxSending({}).then(function(serviceResponce){
                                if(isError(serviceResponce)) return;
                                scope.clickHandler.apply(this, arguments); 
                            });
                        }
                        else{
                            if(isError(EMRActionFaxService.serviceResponse)) return;
                            scope.clickHandler.apply(this, arguments); 
                        }
                    }
                     
                }); 
                element.bind('click', function () { 
                    //checking if the api is sent or not 
                    if(!EMRActionFaxService.isFaxEnabledServiceCallSent){
                        EMRActionFaxService.faxserviceValidationforFaxSending({}).then(function(serviceResponce){
                            if(isError(serviceResponce)) return;
                            scope.clickHandler.apply(this, arguments); 
                        })
                    }
                    else{
                        //if api call is alrdy sent then show the error msg from the response of api call without calling again
                        if(isError(EMRActionFaxService.serviceResponse)) return;
                        scope.clickHandler.apply(this, arguments); 
                    }
                   
                     
                }); 
            } 
        } 
    }]);
angular.module('EMR.Admin').service("EMRActionFaxService",['CommonPostService', '$q', function(CommonPostService, $q){
    //to check if the api is sent or not
    this.isFaxEnabledServiceCallSent = false;
    this.serviceResponse;
    var that = this;
    this.faxserviceValidationforFaxSending = function(faxservicePostdata) {
        faxservicePostdata.practicemodel = EMRPracticeModel;
        faxservicePostdata.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Fax_EHRFax() + "ValidationforFaxSending", faxservicePostdata).then(function (result) {
            that.isFaxEnabledServiceCallSent = true;
            that.serviceResponse = result;
            return result;
        });
       
    };
    /**
     * 
     * @param {Function} fun represents the function to execute when fax is enabled
     * @param {this} context represents the object to which the functions this should point to
     * @param {arguments} args represents the array of values to be passed as arguments to the function 
     * @returns 
     */
    this.callCustomFunctionAfterValidatingFaxEnabled = function (fun, context, args) {
        if (typeof fun !== 'function') return; //function is must
        if (!this.isFaxEnabledServiceCallSent) {
            this.faxserviceValidationforFaxSending({}).then(function (serviceResponce) {
                if (isError(serviceResponce)) return;
                fun.apply(context, args);
            })
        }
        else {
            //if api call is alrdy sent then show the error msg from the response of api call without calling again
            if (isError(this.serviceResponse)) return;
            fun.apply(context, args);
        }
    };
}]);
